import React, { useState } from 'react';
import './Calculator.css';
import Footer from '../../general/footer/Footer';
import SIP from './sip/SIP';
import EMI from './emi/EMI';
import EducationCalculator from './education/Education';
import MarriageCalculator from './marriage/MarriageCalculator';
import LumpSumCalculator from './lumpsum/Lumpsum';
import Lifeinsurance from './insurance/Lifeinsurance';
import Retirement from './retirement/Retirement';
import House from './house/House';
import Car from './car/Car';
import Vacation from './vacation/Vacation';
import Delay from './delay/Delay';
import SipoMeter from './sipometer/SipoMeter';

const financialCalculators = [
  "SIP Calculator",
  "Marriage Planning",
  "Education Planning",
  "SIP-O-Meter",
  "Lumpsum",
  "Life Insurance Planning",
  "Retirement Planning",
  "EMI Calculator",
  "House Planning",
  "Car Planning",
  "Vacation Planning",
  "Delay Cost"
];

const Calculator = () => {
  const [selectedCalc, setSelectedCalc] = useState(null);

  const renderCalculator = () => {
    switch (selectedCalc) {
      case "SIP Calculator":
        return <SIP />;
      case "EMI Calculator":
        return <EMI />;
      case "Education Planning":
        return <EducationCalculator />;
      case "Marriage Planning":
        return <MarriageCalculator />  
      case "Lumpsum":
        return <LumpSumCalculator />
      case "Life Insurance Planning":
        return <Lifeinsurance />
      case "Retirement Planning":
        return <Retirement />
      case "House Planning":
        return <House />
      case "Car Planning":
        return <Car />
      case "Vacation Planning":
        return <Vacation />
      case "Delay Cost":
        return <Delay />
      case "SIP-O-Meter":
        return <SipoMeter />                
      default:
        return null;
    }
  };

  return (
    <div>
      {/* Header */}
      <section className="blog-section2">
        <div className="blog-heading2">
          <span className="blog-label2">Calculator</span>
          <h2 className="blog-title2">
            <span className="highlight2">Financial Calculators</span>
          </h2>
          <p className="blog-description2">
            Plan smarter with our financial calculators—covering SIPs, EMIs, insurance, tax, retirement, and life goals like home, car, vacation, marriage, education, and more.
          </p>
        </div>
      </section>

      {/* Calculator selection buttons */}
      <section className="calculator-section">
        <div className="calculator-category">
          <div className="calculator-grid">
            {financialCalculators.map((calc, index) => (
              <button
                key={index}
                className={`calc-button ${selectedCalc === calc ? 'active' : ''}`}
                onClick={() => setSelectedCalc(calc)}
              >
                {calc}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Show only selected calculator */}
      <div style={{ marginTop: '40px' }}>
        {renderCalculator()}
      </div>

      {/* Footer */}
      <br /><br /><br /><br /><br /><br />
      <Footer />
    </div>
  );
};

export default Calculator;
